
import React, { useState, useEffect, useRef } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';


import FlashlightOnIcon from '@mui/icons-material/FlashlightOn';
import FlashlightOffIcon from '@mui/icons-material/FlashlightOff';
//EXCEL TEST
//import * as FileSaver from 'file-saver';
//import XLSX from 'sheetjs-style';
//import * as Cognito from "amazon-cognito-identity-js";
//DATA
//import { jsonFoodList } from './Data.js';
// TODO remove, this demo shouldn't need to reset the theme.


import { AuthContext } from "./Auth/AuthContext.jsx"




import Webcam from 'react-webcam';
import { BrowserMultiFormatReader, BarcodeFormat } from '@zxing/library';

//import { useZxing } from "react-zxing";
import { OpenFoodFactsApi } from 'openfoodfac-ts';
import { useNavigate } from "react-router-dom";

const defaultTheme = createTheme();



  




export default function ScanBarcode() {
  const { user, signOut, getValue, getSession } = React.useContext(AuthContext)
  const navigate = useNavigate()  

  //███████ ████████  █████  ████████ ███████ 
  //██         ██    ██   ██    ██    ██      
  //███████    ██    ███████    ██    █████   
  //     ██    ██    ██   ██    ██    ██      
  //███████    ██    ██   ██    ██    ███████ 
  const webcamRef = useRef(null);
  const [devices, setDevices] = useState([]);

  const [error, setError] = useState('');
  const [scanning, setScanning] = useState(true);
  const [torchEnabled, setTorchEnabled] = useState(false);
  
  const [waitState, setWaitState] = React.useState(false);
  const [state, setState] = React.useState("init");
  const [barcode, setBarcode] = React.useState("----");
  const [ofProduct, setOfProduct] = React.useState({});
  const [selectedDeviceId, setSelectedDeviceId] = React.useState("");
  const [videoInputDevices, setVideoInputDevices] = React.useState([]);

  const beep=()=> {
    var snd = new Audio("data:audio/wav;base64,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");  
    snd.play(); 
  }


  let test = ['no','due']
  // ██████  █████  ███    ███ ███████ ██████   █████      ██████  ███████ ██████  ███    ███ ██ ███████ ███████ ██  ██████  ███    ██ 
  //██      ██   ██ ████  ████ ██      ██   ██ ██   ██     ██   ██ ██      ██   ██ ████  ████ ██ ██      ██      ██ ██    ██ ████   ██ 
  //██      ███████ ██ ████ ██ █████   ██████  ███████     ██████  █████   ██████  ██ ████ ██ ██ ███████ ███████ ██ ██    ██ ██ ██  ██ 
  //██      ██   ██ ██  ██  ██ ██      ██   ██ ██   ██     ██      ██      ██   ██ ██  ██  ██ ██      ██      ██ ██ ██    ██ ██  ██ ██ 
  // ██████ ██   ██ ██      ██ ███████ ██   ██ ██   ██     ██      ███████ ██   ██ ██      ██ ██ ███████ ███████ ██  ██████  ██   ████ 
  useEffect(() => {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then(stream => {
        return navigator.mediaDevices.enumerateDevices();
      })
      .then(devices => {
        const videoDevices = devices.filter(device => device.kind === 'videoinput');
        setDevices(videoDevices);

        if (videoDevices.length > 0) {
          setSelectedDeviceId(videoDevices[0].deviceId);
        }
        setTorchEnabled(false);
      })
      .catch(err => {
        setError('Error accessing webcam: ' + err.message);
      });
  }, []);

  useEffect(() => {
    let intervalId;
    const codeReader = new BrowserMultiFormatReader();

    if (scanning && webcamRef.current) {
      intervalId = setInterval(() => {
        const imageSrc = webcamRef.current.getScreenshot();
        if (imageSrc) {
          codeReader.decodeFromImage(undefined, imageSrc, { formats: [BarcodeFormat.EAN_13] }).then(result => {
            //
            //setBarcode(result.text);
            let bc = result.getText()
            setBarcode(bc);
            
            getFood(bc);
            beep();
            setScanning(false);
          }).catch(err => {
            // Handle decoding errors, e.g., no EAN-13 barcode detected
          });
        }
      }, 1000); // Adjust interval for faster or slower scanning
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [scanning, webcamRef, setBarcode]);


  const test_reader = () => {
    let bc = barcode==='0044000055509'?'7622210157324':barcode==='7622210157324'?'':'0044000055509';
    setBarcode(bc);
            
    getFood(bc);
    beep();
  }

  const handleAddProduct = (event) => {
    console.log(event.target)
    navigate("/foods", { state: { product: ofProduct } })
  };

  const handleDeviceChange = (event) => {
    setSelectedDeviceId(event.target.value);
  };

  const handleDeviceChange2 = (event) => {
    setSelectedDeviceId(event.target.value);
  };

  const toggleScanning = () => {
    setScanning(!scanning);
    setBarcode('');
    setError('');
  };
  let value = "value1"

 
  const getFood = async (bc) => {
    //alert(bc)
    const openFoodFactsApi = new OpenFoodFactsApi();
    const product = await openFoodFactsApi.findProductByBarcode(bc);
    setOfProduct(product)
    console.log(product);
  
    //const countries = await openFoodFactsApi.findCountries();
  }


  
  

  const toggleTorch = () => {
    const stream = webcamRef.current && webcamRef.current.video.srcObject;
    if (stream instanceof MediaStream) {
      const track = stream.getVideoTracks()[0];
      if (track) {
        const constraints = track.getConstraints();
        constraints.advanced = [{ torch: !torchEnabled }];
        track.applyConstraints(constraints)
          .then(() => setTorchEnabled(!torchEnabled))
          .catch(err => setError('Error toggling torch: ' + err));
      }
    }
  };




  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >

  
          


      <Grid container spacing={1}  direction="row"  justifyContent="flex-end"  alignItems="center">
        <Grid item xs={3}><b>CODE:</b></Grid><Grid item xs={9}>{barcode}</Grid>
        <Grid item xs={3}>Name:</Grid><Grid item xs={9}>{ofProduct?ofProduct.product_name:""}</Grid>
        <Grid item xs={3}>KCal:</Grid><Grid item xs={3}>CHO:</Grid><Grid item xs={3}>FAT:</Grid><Grid item xs={3}>PROT:</Grid>
        <Grid item xs={3}>{ofProduct&&ofProduct.nutriments?ofProduct.nutriments["energy-kcal_100g"]:""}</Grid>
        <Grid item xs={3}>{ofProduct&&ofProduct.nutriments?ofProduct.nutriments.carbohydrates_100g:""}</Grid>
        <Grid item xs={3}>{ofProduct&&ofProduct.nutriments?ofProduct.nutriments.fat_100g:""}</Grid>
        <Grid item xs={3}>{ofProduct&&ofProduct.nutriments?ofProduct.nutriments.proteins_100g:""}</Grid>
        <Grid item xs={6}>
          {ofProduct&&ofProduct.image_url
          ?<img src={ofProduct.image_url} height="300"/>
          :""
        }
        </Grid>
        <Grid item xs={6}>
          {ofProduct&&ofProduct.image_nutrition_url
          ?<img src={ofProduct.image_nutrition_url} height="300"/>
          :""
        }
        </Grid>
        
        <Grid item xs={12}>
          {(barcode && ofProduct && ofProduct.product_name)
          ?<Button onClick={handleAddProduct} variant="contained"  fullWidth={true}>ADD</Button>
         :""
        }
        </Grid>
      
      
      
      
        <Grid item xs={12}>
          {/*
      <select onChange={handleDeviceChange} value={selectedDeviceId}>
            {devices.map(device => (
              <option key={device.deviceId} value={device.deviceId}>{device.label || `Camera ${device.deviceId}`}</option>
            ))}
          </select>
          */}
          

          </Grid>
          <Grid item xs={9}>
          <Select
              onChange={(e, d)=>handleDeviceChange2(e, d)}
              id="select-camera"
              value={selectedDeviceId}
              label="Camera"
              sx={{ height: '4rem', width:'100%'}}
              style={{ width: "100%" }}
              variant="outlined"
              >
              {devices.map(device => (
                <MenuItem key={device.deviceId} value={device.deviceId}>{device.label || `Camera ${device.deviceId}`}</MenuItem>
              
              ))}
                
            </Select>
            </Grid>
            <Grid item xs={3}>
          <Button onClick={toggleTorch} variant="contained" fullWidth={true} >{torchEnabled ? <FlashlightOffIcon > OFF </FlashlightOffIcon >: <FlashlightOnIcon > ON </FlashlightOnIcon>}</Button>
   
          </Grid>
          <Grid item xs={10}>
            <p>{error}</p>
            <Button onClick={toggleScanning} variant="contained"  fullWidth={true}>{scanning ? 'Stop Scanning' : 'Start Scanning'}</Button>
          </Grid>
         
          <Grid item xs={2}>
            <Button onClick={test_reader} variant="contained"  fullWidth={true}>TEST</Button>
          </Grid>

          <Grid item xs={12}>
          <Webcam
          style={{ height: 300, width: '100%' }}
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={{ deviceId: selectedDeviceId ? { exact: selectedDeviceId } : undefined, focusMode: 'continuous', 
            autoGainControl:true,
            facingMode: 'environment' }}
          />
          </Grid>
          </Grid>
      </Box>


      </Container>
    </ThemeProvider>
  );
}

